import React from 'react'
import { connect } from 'react-redux'
import { icons } from '../../../constants'
import { Column } from 'primereact/column'
import { Dialog } from 'primereact/dialog'
import { InputText } from 'primereact/inputtext'
import { InputTextarea } from 'primereact/inputtextarea'
import { Button } from 'primereact/button'
import { Page } from '../../../components/page/Page'
import { actions } from '../parametroEmpresa.actions'
import utils from '../../../utils/index'
import { ParametroEmpresaForm } from './ParametroEmpresaForm'
import { LoadingSpinner } from '../../../components/loadingSpinner/LoadingSpinner'
import storage from '../../../services/stoage.service'
import { logarAcesso } from '../../../services/api-log-acesso'
import { messageActions } from '../../../store/message'
import { ConfirmarRemocaoParametro } from '../../../components/parametros/ConfirmarRemocaoParametro'
import {
  ACAO_SALVAR,
  acaoAoSalvar,
  comNomeParaGravar,
  isNomeEmUso,
  isNomeVazio,
  podeRemover,
  prepararEdicao,
} from '../../../utils/credencialMascarada'

const mapStateToProps = (state) => {
  return {
    columns: state.crudParametroEmpresaState.columns,
    messages: state.crudParametroEmpresaState.messages,
    parametros: state.crudParametroEmpresaState.currentRecord.parametros,
    records: state.crudParametroEmpresaState.records,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    load: () => dispatch(actions.load()),
    setRecords: (parametros) => dispatch(actions.setRecords(parametros)),
    deleteKey: (key) => dispatch(actions.deleteKey(key)),
    insertItemConfiguracao: (configuracaoItem, recarregar) =>
      dispatch(actions.insertItemConfiguracao(configuracaoItem, recarregar)),
    showError: (mensagem) => dispatch(messageActions.showMessages([mensagem], 'error')),
  }
}

class ParametroEmpresaFormPageContainer extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      permissoes: utils.getPermissoesPorMenu(
        storage.getMenus(),
        storage.getOidCurrentMenu(),
        null,
        storage.getPortalCliente()
      ),
    }
    actions.afterSave = () => {
      this.props.load()
    }
  }

  componentDidMount() {
    logarAcesso().then()
    this.props.load()
  }

  saveNewParameter = () => {
    const { parametroAnterior, novoParametro } = this.state
    const parametro = comNomeParaGravar(this.state.parametro, parametroAnterior, novoParametro)
    if (isNomeVazio(parametro)) {
      this.props.showError(utils.getMessage(this.props.messages, 'parametrosempresa.label.chaveObrigatoria'))
      return
    }
    if (isNomeEmUso(this.props.records, parametro, parametroAnterior, novoParametro)) {
      this.props.showError(utils.getMessage(this.props.messages, 'parametrosempresa.label.nomeJaExiste'))
      return
    }
    if (novoParametro) {
      this.props.insertItemConfiguracao(parametro)
      this.setState({ parametroSelecionado: null, parametro: null, displayDialog: false })
      return
    }
    const { credencialMascarada } = this.state
    const acao = acaoAoSalvar(parametro, parametroAnterior, credencialMascarada)
    if (acao === ACAO_SALVAR.MANTER) {
      // Credencial nao alterada: o back nunca manda o valor real, entao nao ha o que reenviar.
      this.setState({ parametroSelecionado: null, parametro: null, displayDialog: false })
      return
    }
    if (acao === ACAO_SALVAR.RENOMEAR_SEM_VALOR) {
      this.props.showError(utils.getMessage(this.props.messages, 'parametrosempresa.label.credencialRenomear'))
      return
    }
    // Sem trocar a linha da grade antes da resposta: o valor digitado (credencial, inclusive) ficaria em claro na tela
    // se o recarregar falhasse. A grade vem do back, que devolve a credencial mascarada.
    // Mesmo nome: o POST sobrescreve o valor. Antes a tela apagava a chave e inseria de novo, e uma insercao recusada
    // ou com falha deixava a chave sem valor - com credencial mascarada, sem ter como redigitar.
    const renomeado = parametro.id !== parametroAnterior.id
    // Renomeando, recarrega uma vez so, depois do delete: dois recarregamentos em paralelo podiam chegar fora de ordem
    // e mostrar a chave antiga ja apagada.
    this.props.insertItemConfiguracao(parametro, !renomeado).then((gravou) => {
      // Nome mudou: so depois de gravar com o nome novo apaga o antigo, e recarrega para a lista mostrar so o novo.
      if (gravou && renomeado) {
        // Se o delete falhar, a action ja mostra o erro e recarrega: a lista mostra as duas chaves.
        this.props.deleteKey(parametroAnterior.id).then((removeu) => {
          if (removeu) {
            this.props.load()
          }
        })
      }
    })
    this.setState({ parametroSelecionado: null, parametro: null, displayDialog: false })
  }

  // Remover apaga de verdade a chave SELECIONADA na lista (nao o nome digitado no campo) e, com a credencial
  // mascarada, o valor nao pode ser redigitado de memoria: pede confirmacao citando a chave.
  confirmarRemocao = () => {
    if (podeRemover(this.state)) {
      this.setState({ confirmarRemocao: true })
    }
  }

  buildDialogConfirmarRemocao = () => (
    <ConfirmarRemocaoParametro
      visible={this.state.confirmarRemocao}
      chave={this.state.parametroSelecionado ? this.state.parametroSelecionado.id : null}
      texto={utils.getMessage(this.props.messages, 'parametrosempresa.label.confirmarRemover')}
      confirm={this.delete}
      hideDialog={() => this.setState({ confirmarRemocao: false })}
    />
  )

  delete = () => {
    if (this.state.parametroSelecionado && this.state.parametroSelecionado.id) {
      let selectedKey = this.state.parametroSelecionado.id
      this.props.deleteKey(selectedKey)
      let index = this.findSelectedParameterIndex()
      let parametrosRestantes = this.props.records.filter((val, i) => i !== index)
      this.props.setRecords(parametrosRestantes)
    }
    this.setState({
      parametroSelecionado: null,
      parametro: null,
      displayDialog: false,
    })
  }
  findSelectedParameterIndex = () => {
    return this.props.records.indexOf(this.state.parametroSelecionado)
  }

  newHandler() {
    this.setState({
      parametro: { id: '', value: '' },
      displayDialog: true,
      novoParametro: true,
      credencialMascarada: false,
    })
  }

  resolveBotaoNovo() {
    if ((this.state.permissoes && this.state.permissoes.inserir) || !this.state.permissoes) {
      return (
        <Button
          onClick={(e) => this.newHandler(this)}
          label={utils.getMessage(this.props.messages, 'label.novo')}
          className="p-button-success"
          icon={icons.PLUS_ICON}
          style={{ marginRight: '.25em' }}
        />
      )
    }
    return null
  }
  updateProperty(property, value) {
    let parametro = this.state.parametro
    parametro[property] = value
    this.setState({ parametro: parametro })
  }

  onSelectionChange = (e) => {
    this.setState({ parametroSelecionado: e.value })
  }

  onParametroSelecionado = (e) => {
    const { parametro, credencialMascarada } = prepararEdicao(e.data)
    this.setState({
      displayDialog: true,
      parametro,
      parametroAnterior: Object.assign({}, e.data),
      novoParametro: false,
      credencialMascarada,
    })
  }

  dialogFooter(paramentro) {
    return (
      <div className="ui-dialog-buttonpane p-clearfix">
        <Button
          label={utils.getMessage(this.props.messages, 'label.remover')}
          icon="pi pi-times"
          disabled={(paramentro ? paramentro.isConfiguracaoLottus : false) || !podeRemover(this.state)}
          onClick={this.confirmarRemocao}
        />
        <Button
          label={utils.getMessage(this.props.messages, 'label.salvar')}
          icon="pi pi-check"
          onClick={this.saveNewParameter}
        />
      </div>
    )
  }

  buildDialog = () => {
    return (
      <Dialog
        visible={this.state.displayDialog}
        width="300px"
        header="Parâmetros"
        modal={true}
        footer={this.dialogFooter(this.state.parametro)}
        onHide={() => this.setState({ displayDialog: false })}
        contentStyle={{ maxHeight: '500px' }}
      >
        {this.state.parametro && (
          <div className="p-grid p-fluid">
            <div className="p-col-4" style={{ padding: '.75em' }}>
              <label htmlFor="id">{utils.getMessage(this.props.messages, 'parametrosempresa.label.chave')}</label>
            </div>
            <div className="p-col-8" style={{ padding: '.5em' }}>
              {/* Linha global da Lottus: salvar grava uma copia na empresa e o delete do nome antigo nao acha nada
                  nela - renomear viraria duplicar. Editar o valor (sobrescrever na empresa) continua. */}
              <InputText
                id="id"
                onChange={(e) => this.updateProperty('id', e.target.value)}
                value={this.state.parametro.id}
                disabled={!this.state.novoParametro && !!this.state.parametro.isConfiguracaoLottus}
              />
            </div>

            <div className="p-col-4" style={{ padding: '.75em' }}>
              <label htmlFor="value">{utils.getMessage(this.props.messages, 'parametrosempresa.label.valor')}</label>
            </div>
            <div className="p-col-8" style={{ padding: '.5em' }}>
              <InputTextarea
                id="value"
                rows={1}
                cols={30}
                style={{ maxHeight: '450px' }}
                autoResize={true}
                onChange={(e) => this.updateProperty('value', e.target.value)}
                value={this.state.parametro.value}
                placeholder={
                  this.state.credencialMascarada
                    ? utils.getMessage(this.props.messages, 'parametrosempresa.label.credencialPreenchida')
                    : undefined
                }
              />
            </div>
          </div>
        )}
      </Dialog>
    )
  }

  buildHeader = () => {
    return (
      <div>
        <div className="p-grid p-justify-start p-align-center">
          <h4>{utils.getMessage(this.props.messages, 'parametrosempresa.label.parametrosempresa')}</h4>
        </div>

        <div className="p-toolbar-group-left">{this.resolveBotaoNovo()}</div>
      </div>
    )
  }
  defineColumns = () => {
    const visibleColumns = this.props.columns.filter((col) => col.visible)
    return visibleColumns.map((col) => {
      return <Column {...col} key={col.field} sortField={col.columnSortField} />
    })
  }

  buildContent = () => {
    return (
      <div>
        {this.buildDialog()}
        {this.buildDialogConfirmarRemocao()}
        <ParametroEmpresaForm
          {...this.props}
          onSelectionChange={this.onSelectionChange}
          onParametroSelecionado={this.onParametroSelecionado}
          onPage={this.onPage}
          onSort={this.onSort}
          columns={this.defineColumns()}
        />
      </div>
    )
  }

  render() {
    if (this.props.columns && this.props.columns.length > 0) {
      return <Page header={this.buildHeader()} content={this.buildContent()} />
    }
    return <LoadingSpinner />
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ParametroEmpresaFormPageContainer)
